import { useCurrentProfile } from '@map/state/profile';
import { windowExtended } from '@map/types';
import OnDemandLocalizationProvider from '@shared/components/OnDemandLocalizationProvider';
import { useCurrentLocale } from '@shared/hooks/intl';
import { type ReactNode } from 'react';

import messageBundles from 'virtual:i18n-messages?bundles=skill_survey,mobile';

const loadLocale = async (locale: string, _intlLocale?: string) => {
  const language = locale.split('-')[0] ?? Object.keys(messageBundles)[0]!;
  return (await messageBundles[language]?.()) ?? (await Object.values(messageBundles)[0]!());
};

const LocalizationProvider = ({ children }: { children: ReactNode }) => {
  const locale = useCurrentLocale();
  const profile = useCurrentProfile();
  const allowedLocales = profile.allowed_locales ?? windowExtended.project.allowed_locales;

  return (
    <OnDemandLocalizationProvider
      locale={locale === 'ar' ? 'ar-SA' : locale}
      loadLocale={loadLocale}
      allowedLocales={allowedLocales}
    >
      {children}
    </OnDemandLocalizationProvider>
  );
};

export default LocalizationProvider;
